'use client';

import { useRef } from 'react';
import { useInView } from 'motion/react';

const AUTOPLAY_IN_VIEW_OPTIONS = {
  amount: 0.2,
  margin: '0px 0px -10% 0px',
} as const;

/** True while the element is in (or near) the viewport; pauses again when scrolled away. */
export function useAutoplayInView<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null);
  const isInView = useInView(ref, AUTOPLAY_IN_VIEW_OPTIONS);

  return { ref, isInView };
}
